// src/pages/Contact.js
import React, { useState } from 'react'
import { Box, Typography, Container, TextField, Button, Snackbar, Alert, GlobalStyles } from '@mui/material'
import { styled } from '@mui/system'
import Background from '../components/Background'

const ACCENT = '#467EE5'
const MainWrapper = styled(Box)({
  position: 'relative', bgcolor: '#000', color: '#fff',
  minHeight: '100vh', overflow: 'hidden',
})
const SectionTitle = styled(Typography)({
  color: '#fff', fontWeight: 800, fontSize: '2.5rem',
  marginBottom: '1.5rem',
})

export default function Contact() {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [snackbar, setSnackbar] = useState({ open: false, severity: 'success', text: '' })

  const handleSubmit = async e => {
    e.preventDefault()
    try {
      const res = await fetch(
        'https://scout-backend-ieo2.onrender.com/api/contact',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, message }),
        }
      )
      if (!res.ok) throw new Error(await res.text())
      setSnackbar({ open: true, severity: 'success', text: 'Message sent!' })
      setEmail(''); setMessage('')
    } catch {
      setSnackbar({ open: true, severity: 'error', text: 'Failed to send.' })
    }
  }

  return (
    <MainWrapper>
      <GlobalStyles styles={{ html: { scrollBehavior: 'smooth' } }} />
      <Background />
      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1, py: { xs:8, md:12 } }}>
        <SectionTitle variant="h3" align="center">Contact</SectionTitle>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            variant="filled" fullWidth label="Your Email"
            value={email} onChange={e => setEmail(e.target.value)}
            InputProps={{ disableUnderline: true }}
            sx={{
              bgcolor: 'rgba(255,255,255,0.1)', borderRadius: 1, mb: 2,
              '& .MuiFilledInput-input': { color: '#fff' },
              '& .MuiFormLabel-root': { color: 'rgba(255,255,255,0.7)' },
            }}
          />
          <TextField
            variant="filled" fullWidth label="Message" multiline rows={4}
            value={message} onChange={e => setMessage(e.target.value)}
            InputProps={{ disableUnderline: true }}
            sx={{
              bgcolor: 'rgba(255,255,255,0.1)', borderRadius: 1, mb: 4,
              '& .MuiFilledInput-input': { color: '#fff' },
              '& .MuiFormLabel-root': { color: 'rgba(255,255,255,0.7)' },
            }}
          />
          <Button
            type="submit" variant="contained" size="large"
            sx={{
              px: 6, py: 1.5, fontWeight: 700, borderRadius: 999,
              bgcolor: ACCENT, '&:hover': { bgcolor: '#356DC7' },
            }}
          >
            Send
          </Button>
        </Box>
      </Container>
      <Snackbar
        open={snackbar.open} autoHideDuration={4000}
        onClose={() => setSnackbar(s => ({ ...s, open: false }))}
      >
        <Alert
          onClose={() => setSnackbar(s => ({ ...s, open: false }))}
          severity={snackbar.severity} sx={{ width: '100%' }}
        >
          {snackbar.text}
        </Alert>
      </Snackbar>
    </MainWrapper>
  )
}
